import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

import { ImageProps } from "./";

const Image = (props: ImageProps) => (<StaticImage className={props.className} src="../../images/mobile_app.png" alt="Mobile application" />);
export default Image;
